import { MALEK_CART_ITEMS_KEY } from "src/constants/storageKeys";
import { CartItemType } from "src/types/cart/CartItem";
import { getStorageItem, saveStorageItem } from "./storage";


export const storageAddCartItem = (item: CartItemType) => {
    const cartItems = getStorageItem(MALEK_CART_ITEMS_KEY) || [];
    const itemExists = cartItems.some((itm: CartItemType) => itm.slug === item.slug);

    if (!itemExists) {
        saveStorageItem(MALEK_CART_ITEMS_KEY, [item, ...cartItems]);
    }
};

export const storageRemoveCartItem = (slug: string) => {
    const cartItems = getStorageItem(MALEK_CART_ITEMS_KEY) || [];
    const updatedCartItems = cartItems.filter((item: CartItemType) => item.slug !== slug);
    saveStorageItem(MALEK_CART_ITEMS_KEY, updatedCartItems);
};

export const storageCartReset = () => {
    saveStorageItem(MALEK_CART_ITEMS_KEY, []);
};

export const storageUpdateCartItemQty = (slug: string, qty: number) => {
    const cartItems = getStorageItem(MALEK_CART_ITEMS_KEY) || [];
    const updatedItems = cartItems.map((item: CartItemType) =>
        item.slug === slug ? { ...item, qty } : item
    );
    saveStorageItem(MALEK_CART_ITEMS_KEY, updatedItems);
};
